export default __webpack_public_path__ + "static/media/214.032611fa.png";